import { render, staticRenderFns } from "./PageSearch.vue?vue&type=template&id=62a3cbae&"
import script from "./PageSearch.vue?vue&type=script&lang=js&"
export * from "./PageSearch.vue?vue&type=script&lang=js&"
import style0 from "./PageSearch.vue?vue&type=style&index=0&id=62a3cbae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports